(function(){
  'use strict';

  function isUniformPage(){
    return document.body && document.body.classList.contains('empress-uniform-bg');
  }

  function isVeryLight(rgb){
    if(!rgb || rgb === 'transparent' || rgb === 'rgba(0, 0, 0, 0)') return false;
    var m = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if(!m) return false;
    var r=+m[1], g=+m[2], b=+m[3];
    return r >= 245 && g >= 245 && b >= 245;
  }

  function shouldSkip(el){
    if(!el || el.nodeType !== 1) return true;
    return /^(IMG|PICTURE|VIDEO|CANVAS|SVG|IFRAME|SOURCE|SCRIPT|STYLE|LINK|META)$/.test(el.tagName);
  }

  function cleanElement(el){
    if(shouldSkip(el)) return;
    var cs;
    try { cs = window.getComputedStyle(el); } catch(e) { return; }
    if(!cs) return;

    var bg = cs.backgroundColor;
    var bgImage = cs.backgroundImage;
    if(isVeryLight(bg) && (!bgImage || bgImage === 'none')){
      el.style.setProperty('background-color','#111111','important');
    }

    if((el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') && isVeryLight(bg)){
      el.style.setProperty('background-color','#181818','important');
      el.style.setProperty('color','#f4ead0','important');
      el.style.setProperty('border-color','rgba(201,168,76,.45)','important');
    }
  }

  function sweep(root){
    if(!isUniformPage()) return;
    document.documentElement.classList.add('empress-uniform-html');
    root = root || document.body;
    cleanElement(root);
    var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for(var i=0;i<all.length;i++) cleanElement(all[i]);
  }

  var scheduled = false;
  function scheduleSweep(){
    if(scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function(){
      scheduled = false;
      sweep(document.body);
    });
  }

  function start(){
    if(!isUniformPage()) return;
    sweep(document.body);
    setTimeout(scheduleSweep,250);
    setTimeout(scheduleSweep,900);
    setTimeout(scheduleSweep,1800);

    if(window.MutationObserver){
      var observer = new MutationObserver(function(mutations){
        var hasNew = false;
        for(var i=0;i<mutations.length;i++){
          if(mutations[i].addedNodes && mutations[i].addedNodes.length){ hasNew = true; break; }
        }
        if(hasNew) scheduleSweep();
      });
      observer.observe(document.body,{childList:true,subtree:true});
    }

    window.addEventListener('load',scheduleSweep);
    window.addEventListener('orientationchange',function(){setTimeout(scheduleSweep,150);});
    window.addEventListener('resize',function(){setTimeout(scheduleSweep,100);});
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
})();
